<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Fixed Asset Maintenance History
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>

      <b-row >
        <b-col lg="5">
            <b-input-group>
                <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                <b-form-input v-model="model.asetid" readonly class="mr-1" :state="!$v.model.asetkey.$error"></b-form-input>  
                <b-form-input v-model="model.asdesc" readonly style="width:45% !important;" :state="!$v.model.asetkey.$error"></b-form-input>                                        
                <b-input-group-append>
                <b-btn text="Button" @click="lkuFixedAssetShow=true" :disabled="(model.requestkey)">
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col lg="6">
                <b-input-group >
                    <b-input-group-prepend><label>Model/Type</label></b-input-group-prepend>
                    <b-form-input v-model="model.asmodel" readonly style="width:30% !important;"></b-form-input>
                    <b-input-group-prepend class="ml-2 pt-2 mr-1"><span>S/N &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    <b-input-group-prepend class="ml-2">
                        <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
                    </b-input-group-prepend>
                </b-input-group>
        </b-col>
      </b-row>


      <b-card no-body>
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="4">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>  
                </b-col> 
                <b-col lg="5">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="1"
                    label-size="sm"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                      <b-form-checkbox value="maintSpkNo">Workorder No.</b-form-checkbox>
                      <b-form-checkbox value="vendorinfo">vendor</b-form-checkbox>
                      <b-form-checkbox value="referDoc">Maintenance Doc#</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
                <b-col lg="3">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblData.fields"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy"
                :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
                <template v-slot:cell(tanggal)="data">
                {{ data.item.tanggal | moment("DD MMM YYYY") }}
                </template>
                <template v-slot:cell(vendorinfo)="data">
                    <span v-if="(data.item.internal==1)">INTERNAL</span>
                    <span v-else>{{data.item.vendorinfo}}</span>
                </template>

                <template v-slot:cell(totalinv)="data"> {{data.item.matauang}} &nbsp;&nbsp;  {{data.item.totalinv | numFormat}}
                </template>
            </b-table>
          <b-row class="mt-2">
            <b-col cols="4">            
              <b-pagination
                align="left"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
            <b-col cols="5">            
              <div style="text-align:center;">
                <div>
                  Showing {{(tblData.page - 1) * tblData.limit + 1}}
                  to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                  of {{tblData.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                  <select  v-model="tblData.limit"  style="width:60px;">
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>                            
                    <option>25</option>
                    <option>30</option>                            
                  </select>
                </div>
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b> {{ filterShow }}</b>  Filter
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col cols="3">
                <div style="font-weight: bold; text-align:right;">Total Maintenance Cost : {{uanguser}}
                    <div style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;" class="pl-2 pt-2 pr-2">
                      {{subtotal.invoice | numFormat }}</div>
                </div>
            </b-col>
          </b-row>

      </b-card>
  </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :catgid="model.assetCatgId" :catgname="model.assetCatgName" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }

            tr.selisih {
              background: yellow;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
     .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
    }
</style>

<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import mtcrecord from "../../apis/maintenrec";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        asetkey: { required },
    },
  }, 
  data() {
    return {
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {account:'',tgl1:'',tgl2:''},
      filterShow:'Show',
      uanguser: this.$store.state.user.matauang,
      rptLines : [],
      subtotal : {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "maintSpkNo",
            thStyle: "width:100px",
            label: "WorkOrder#"
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Mainten.Date"
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "createby",
            thStyle: "width:100px",
            label: "Create By",
            sortable: true
          },
          {
            key: "referDoc",
            label: "Maintenance Doc.Reff",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Total Invoice",
            thStyle: "width:130px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ]
      },
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading, lkuFixedasset},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  methods: {
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;
        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        // this.model.lamathn = lkuData.selected.lamathn;
        // this.model.lamabln = lkuData.selected.lamabln;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.departname = lkuData.selected.departname;
        // console.log('lkuData.selected.departname :',lkuData.selected.departname);
        // this.model.aspurcpri = lkuData.selected.aspurcpri;
        // this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
        // this.model.tanggal=this.model.tanggal || new Date;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },      
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        this.rptLines =  await mtcrecord.list({asetkey: this.model.asetkey, limit: 10000, sortBy:'tanggal'});
        this.tblData.total = this.rptLines.length;        
        this.subtotal.invoice = this.rptLines.reduce((a, b) => a + b.totalinv, 0);
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await mtcrecord.exportxls(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
